<template>
  <div class="Television">
    <div class="container one-container">
      <div class="container-content">
        <div class="content-title">广电融媒解决方案</div>
        <div class="content-describe">
          打造融媒体中心的专属智能IP，提供专业可靠的智能播报及汇报服务
        </div>
        <div class="content-btns">
          <div class="btn btn-apply" @click="openApplyDialog">
            免费试用
            <div class="btn-icon"></div>
          </div>
          <div class="btn btn-consult" @click="openContactDialog">
            立即咨询
            <div class="btn-icon"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="container bg1 two-container">
      <div class="container-title">行业痛点</div>
      <div class="container-describe">
        跨界融合提高影响力，业绩考核&内容汇报轻松无忧
      </div>
      <div class="container-pic">
        <div class="pic-item" style="margin-right: 3.125rem">
          <div class="pic-icon">
            <img :src="`${$CdnServerAddress}websit/web/television_icon1.png`" />
          </div>
          <div class="pic-title">
            <div>主播口播内容生成</div>
            <div>成本高，效率低</div>
          </div>
          <div class="pic-underline"></div>
          <div class="pic-content">
            <div class="pic-content-item">
              <div>制作团队依赖</div>
              <div>专业演播室需求高</div>
            </div>
            <div class="pic-content-item">
              <div style="text-align: center; padding-left: 2.1875rem">
                内容生产成本高，制作周期长
              </div>
            </div>
          </div>
        </div>
        <div class="pic-item">
          <div class="pic-icon">
            <img :src="`${$CdnServerAddress}websit/web/television_icon2.png`" />
          </div>
          <div class="pic-title">
            <div>主播塌房离职事件</div>
            <div>带来的不良影响</div>
          </div>
          <div class="pic-underline"></div>
          <div class="pic-content">
            <div class="pic-content-item">
              <div>主播离职影响大</div>
              <div>内容下架问题</div>
            </div>
            <div class="pic-content-item">
              <div style="text-align: center">塌房对品牌负面影响过大</div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg2 three-container">
      <div class="container-title">核心优势</div>
      <div class="container-content">
        <div class="content-video">
          <video
            :src="`${$CdnServerAddress}websit/web/video2.mp4`"
            ref="video"
          ></video>
          <div
            :class="['video-btn', videoStaus ? 'btn-pause' : 'btn-play']"
            @click="playVideo"
          ></div>
        </div>
        <div class="content-item">
          <div
            v-for="(contentItem, contentKey) in contentList"
            :key="contentKey"
            v-show="contentIndex == contentKey"
          >
            <div
              class="item-div"
              v-for="(item, index) in contentItem"
              :key="index"
              :style="{ opacity: item.opacity }"
            >
              {{ item.title }}
              <span>{{ item.content }}</span>
            </div>
          </div>
          <div class="item-change">
            <div
              v-for="(item, index) in contentList"
              :key="index"
              :class="[{ actived: contentIndex == index }]"
              @click="contentIndex = index"
            ></div>
          </div>
        </div>
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg1 four-container">
      <div class="container-title">AI数字IP主播打造</div>
      <div class="container-content">
        <div class="content-item">
          <div class="item-title">助力品牌价值最大化</div>
          <div class="item-content" style="margin-bottom: 1.875rem">
            为广电融媒行业打造专属IP数字主播，挖掘
            <span>文化元素、企业历史、品牌调性</span>
            等元素进行设计，打造具备高识别度的IP型主播。自带流量的IP跨界合作，广告代言、联名周边样样爆款。
          </div>
          <div class="item-content">
            八点八数字已成功打造
            <span
              >新华社小诤、苏州广电苏意、江苏广电阿紫、南京江北新区融媒主播江小北、新华日报新小华、齐鲁网报齐风鲁韵</span
            >
            等知名主播案例。
          </div>
        </div>
        <img :src="`${$CdnServerAddress}websit/web/broadcast_pic1.png`" />
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg2 five-container">
      <div class="container-title">30秒生成高精度数字主播口播视频</div>
      <div class="container-content">
        <div class="content-item">
          <div class="item-title">内容严谨播报，形象稳定可靠</div>
          <div class="item-content">
            <span>AI数字人主播，大屏汇报讲解员。</span>
            通过定制化的数字人形象和多模态交互技术，实现汇报和播报宛如真人的生动性和互动性，且通过垂类大模型技术，使得智能播报视频和宣传海报等和交互展示的内容，
            <span>人员永不流失，不受主播严重负面事件</span>
            影响，导致单位
            <span>公众形象受损</span>
            严重影响融媒中心的口碑和形象。
          </div>
        </div>
        <img :src="`${$CdnServerAddress}websit/web/broadcast_pic2.png`" />
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg1 six-container">
      <div class="container-title">数字主播+大模型变身数字员工</div>
      <div class="container-content">
        <div class="content-item">
          <div class="item-title">刚需展示载体，推动企业效能提升</div>
          <div class="item-content">
            数字员工可应用于<span>企业展厅、汇报接待、活动演出、临展展示</span>等场景，通过大模型的知识能力与用户完成交互，提升品牌形象。
          </div>
        </div>
        <img :src="`${$CdnServerAddress}websit/web/broadcast_pic3.png`" />
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg2 seven-container">
      <div class="container-title">客户案例</div>
      <div class="container-describe">
        以非凡实力成为行业头部客户数字人AIGC应用的不二智选
      </div>
      <div class="container-banner">
        <div
          class="banner-content"
          v-for="(item, index) in bannerList"
          :key="index"
          v-show="bannerIndex == index"
        >
          <div class="banner-left">
            <div class="banner-left-top">
              <div class="top-logo">
                <img :src="item.logo" />
              </div>
              <div class="top-name">{{ item.name }}</div>
            </div>
            <div class="banner-left-middle">
              <div class="middle-title">{{ item.title }}</div>
              <div class="middle-content">{{ item.content }}</div>
            </div>
            <div class="banner-left-bottom">
              <div
                class="bottom-item"
                v-for="(percentItem, percentIndex) in item.percents"
                :key="percentIndex"
              >
                <div class="bottom-item-percent">
                  {{ percentItem.percent }}<span>%+</span>
                </div>
                <div class="bottom-item-percent-title">
                  {{ percentItem.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="banner-right">
            <img :src="item.banner" />
          </div>
        </div>
        <!-- <div class="banner-btn pre" @click="changeBanner(-1)">
          <img :src="`${$CdnServerAddress}websit/web/arrow.svg`" />
        </div>
        <div class="banner-btn next" @click="changeBanner(1)">
          <img :src="`${$CdnServerAddress}websit/web/arrow.svg`" />
        </div> -->
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/common/event-bus";

export default {
  name: "TelevisionPage",
  data() {
    return {
      videoStaus: false,
      contentIndex: 0,
      contentList: [
        [
          {
            title: "智慧大脑",
            content:
              "多国语言问答，秒级响应，实时打断对话，专属大脑训练，内容严谨专业。",
            opacity: 1,
          },
          {
            title: "主动交互",
            content: "多模块感知，人脸识别，语音唤醒，开场词编排。",
            opacity: 1,
          },
          {
            title: "高级数据平台",
            content: "可视化数据平台内容播报、数字孪生指令操作。",
            opacity: 1,
          },
        ],
        [
          {
            title: "智能汇报",
            content:
              "联动PPT，宣传片汇报，上下页语音操作，暂停问答，联动网页多开内嵌，安全可靠。",
            opacity: 1,
          },
          {
            title: "主动交互",
            content: "多模块感知，人脸识别，语音唤醒，开场词编排。",
            opacity: 0,
          },
          {
            title: "高级数据平台",
            content: "可视化数据平台内容播报、数字孪生指令操作。",
            opacity: 0,
          },
        ],
      ],
      contentTimer: null,
      bannerIndex: 0,
      bannerList: [
        {
          id: 1,
          banner: `${this.$CdnServerAddress}websit/web/case2.png`,
          logo: `${this.$CdnServerAddress}websit/web/case_logo2.png`,
          name: "新华日报",
          title: "AI数字人小新和小华",
          content:
            "新华日报作为官媒之一，肩负着传递权威信息、宣传政策和展示成就的重要使命。随着数字化时代的到来，新华日报亟需一种创新的方式来提升其新闻播报、政策宣传和展厅汇报等工作的效果，以更好地适应新时代的要求。新闻播报、短视频等需要一种新颖、互动性强的新闻播报方式，助力数字化转型，符合新质生产力的号召。展厅汇报需要更加专业、高效，能够准确严谨地为上级领导进行工作汇报。",
          percents: [
            { title: "媒体话题度", percent: "23" },
            { title: "数字化转型", percent: "100" },
            { title: "人效", percent: "35" },
          ],
        },
      ],
    };
  },
  mounted() {
    this.contentTimer = setInterval(() => {
      let index = this.contentIndex + 1;
      if (index > this.contentList.length - 1) {
        index = 0;
      }
      this.contentIndex = index;
    }, 5000);
  },
  methods: {
    openApplyDialog() {
      EventBus.$emit("openApplyDialog", { type: 1 });
    },
    openContactDialog() {
      EventBus.$emit("openContactDialog");
    },
    playVideo() {
      this.videoStaus = !this.videoStaus;
      if (this.videoStaus) {
        this.$refs.video.play();
      } else {
        this.$refs.video.pause();
      }
    },
    changeBanner(step) {
      let result = this.bannerIndex + step;
      if (result < 0) {
        result = 0;
      } else if (result > this.bannerList.length - 1) {
        result = this.bannerList.length - 1;
      }
      this.bannerIndex = result;
    },
  },
};
</script>

<style lang="less" scoped>
.Television {
  width: 100%;
  position: relative;
  color: #ffffff;

  .container {
    width: 100%;
    min-height: calc(~"100vh - 64px");
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &.one-container {
      margin-top: 64px;
      background: url("https://bdbcdn.bdbdigital.com/websit/web/scheme2.png")
        center no-repeat #000000;
      background-size: cover;
      position: relative;

      .container-content {
        position: absolute;
        top: 50%;
        left: 14%;
        transform: translate(0, -50%);
        align-items: flex-start;
        flex-direction: column;

        .content-title {
          font-size: 64px;
          font-weight: bold;
          margin-bottom: 40px;
        }

        .content-describe {
          font-size: 24px;
          margin-bottom: 100px;
        }

        .content-btns {
          width: 312px;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .btn {
            width: 134px;
            line-height: 38px;
            border: 1px solid #ffffff99;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &:hover {
              background: #ffffff1a;
            }

            &.btn-apply {
              background: #a6000d;
              border-color: #a6000d;

              &:hover {
                background: #80000f;
                border-color: #80000f;
              }
            }

            .btn-icon {
              width: 16px;
              height: 16px;
              background: url("https://bdbcdn.bdbdigital.com/websit/web/arrow.svg")
                no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }

    &.three-container {
      .container-title {
        margin-bottom: 82px;
      }

      .container-content {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 80px;

        .content-video {
          width: 43%;
          position: relative;
          margin-right: 50px;

          video {
            width: 100%;
          }

          .video-btn {
            width: 64px;
            height: 64px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;

            &.btn-play {
              background: url("https://bdbcdn.bdbdigital.com/websit/web/icon-play.png")
                no-repeat;
              background-size: 100% 100%;
            }

            &.btn-pause {
              display: none;
              background: url("https://bdbcdn.bdbdigital.com/websit/web/icon-pause.png")
                no-repeat;
              background-size: 100% 100%;
            }
          }

          &:hover {
            .btn-pause {
              display: block;
            }
          }
        }

        .content-item {
          margin-right: 0;
          padding: 0;
          justify-content: center;

          & > div {
            margin-bottom: 40px;
            height: 86%;

            &:last-child {
              margin-bottom: 0;
              height: auto;
            }
          }
        }
      }
    }

    &.bg1 {
      background: url("https://bdbcdn.bdbdigital.com/websit/web/bg1.png") center
        no-repeat #000000;
      background-size: cover;
    }

    &.bg2 {
      background: url("https://bdbcdn.bdbdigital.com/websit/web/bg2.png") center
        no-repeat #000000;
      background-size: cover;
    }

    .container-title {
      font-size: 64px;
      font-weight: bold;
      margin-bottom: 40px;
    }

    .container-describe {
      font-size: 24px;
      margin-bottom: 40px;
      color: #bfbfbf;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .container-pic {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      margin-bottom: 80px;

      .pic-item {
        width: 35%;
        background: url("https://bdbcdn.bdbdigital.com/websit/web/bg_4.png")
          right no-repeat #141414;
        background-size: auto 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 48px 0;
        border-radius: 8px;
        cursor: pointer;
        margin-bottom: 0;
        transition: margin-bottom 0.1s;
        margin-top: 20px;

        &:hover {
          margin-top: 0;
        }

        .pic-icon {
          width: 80px;
          margin-bottom: 40px;

          img {
            width: 100%;
          }
        }

        .pic-title {
          font-size: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          margin-bottom: 40px;

          div {
            white-space: nowrap;
          }
        }

        .pic-underline {
          width: 60px;
          height: 2px;
          background: #a6000d;
          margin-bottom: 40px;
        }

        .pic-content {
          width: 100%;

          .pic-content-item {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #bfbfbf;
            margin-bottom: 16px;

            &:last-child {
              margin-bottom: 0;
            }

            div {
              width: 50%;
              padding: 0 10px;
              text-align: right;
              border-right: 1px solid #bfbfbf;

              &:last-child {
                border: none;
                text-align: left;
              }
            }
          }
        }
      }
    }

    .container-content {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 80px;

      img {
        width: 43%;
      }

      .content-item {
        width: 30%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        margin-right: 50px;

        .item-div {
          font-size: 30px;
          color: #ffffff;
          margin-bottom: 60px;
          display: flex;
          align-items: flex-start;
          justify-content: left;
          letter-spacing: 2px;
          flex-direction: column;

          &:last-child {
            margin-bottom: 0;
          }

          span {
            font-size: 16px;
            color: #bfbfbf;
            line-height: 28px;

            &:first-child {
              margin-top: 16px;
            }
          }
        }

        .item-title {
          font-size: 30px;
          color: #ffffff;
          margin-bottom: 30px;
          letter-spacing: 2px;
        }

        .item-content {
          font-size: 16px;
          color: #a1a1a6;
          letter-spacing: 2px;
          line-height: 28px;

          span {
            font-size: 24px;
            color: #ffffff;
          }
        }

        .item-change {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          div {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #595959;
            cursor: pointer;

            &:first-child {
              margin-right: 16px;
            }

            &.actived {
              background: #a6000d;
            }
          }
        }
      }
    }

    .container-banner {
      width: 70%;
      background: #141414;
      border-radius: 8px;
      padding: 24px;
      margin-bottom: 80px;
      position: relative;

      .banner-content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .banner-left {
          width: 42%;
          margin-right: 50px;

          .banner-left-top {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 24px;

            .top-logo {
              width: 60px;
              margin-right: 16px;

              img {
                width: 100%;
              }
            }

            .top-name {
              font-size: 30px;
            }
          }

          .banner-left-middle {
            margin-bottom: 24px;

            .middle-title {
              font-size: 24px;
              margin-bottom: 24px;
            }

            .middle-content {
              color: #bfbfbf;
              line-height: 28px;
            }
          }

          .banner-left-bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            text-align: center;

            .bottom-item {
              .bottom-item-percent {
                font-size: 40px;
                font-weight: bold;
                margin-bottom: 8px;
                color: #a6000d;

                span {
                  font-size: 18px;
                }
              }
            }
          }
        }

        .banner-right {
          width: 58%;

          img {
            width: 100%;
          }
        }
      }

      .banner-btn {
        width: 38px;
        height: 38px;
        border: 1px solid #bfbfbf;
        border-radius: 50%;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;

        &.pre {
          top: 50%;
          left: -5%;
          transform: translate(0, -50%) rotate(180deg);
        }

        &.next {
          top: 50%;
          right: -5%;
          transform: translate(0, -50%);
        }

        img {
          margin-left: 20%;
        }

        &:hover {
          background: #a6000d;
          border-color: #a6000d;
        }
      }
    }

    .container-btns {
      width: 320px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .btn {
        width: 134px;
        line-height: 38px;
        border: 1px solid #ffffff99;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
          background: #ffffff1a;
        }

        &.btn-apply {
          background: #a6000d;
          border-color: #a6000d;

          &:hover {
            background: #80000f;
            border-color: #80000f;
          }
        }

        .btn-icon {
          width: 16px;
          height: 16px;
          background: url("https://bdbcdn.bdbdigital.com/websit/web/arrow.svg")
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>